import {
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  SvgIcon,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import FeaturedPlayListOutlinedIcon from "@mui/icons-material/FeaturedPlayListOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Link } from "react-router-dom";
import { routes } from "../../../app-old/utilities/routes";
import {
  BILLING_ADMIN,
  DATA_DICTIONARY,
  SUPER_ADMIN_ROLE,
  USER_ROLE,
} from "../../Constants/Constants";
import { getPipeNewUI } from "../../Utilities/utils";

function AdminMenu(props) {
  const {
    adminMenuClick,
    closeMenu,
    isSuperAdmin,
    location,
    defaultCompany,
    currentUser,
    roleName,
    refreshHelpSite,
    auth,
  } = props;
  const {
    admin_settings,
    data_dictionary,
    projects,
    custom_data,
    companies,
    users,
    rate_cards,
    collector_management,
    datapipe_list,
    epg_enrichment,
  } = routes;

  const [isNewVersion, setIsNewVersion] = useState(true);

  useEffect(() => {
    const isNewPipeUISavedVal = getPipeNewUI();
    if (isNewPipeUISavedVal !== null) {
      setIsNewVersion(isNewPipeUISavedVal);
    }
  }, []);

  /* istanbul ignore next */
  const handleChange = (tabValue) => {
    let originValue = "";
    const companyName =
      defaultCompany === null ? "All Companies" : defaultCompany.company_name;
    if (
      location.state !== undefined &&
      location.state.activeTab !== undefined
    ) {
      const { activeTab } = location.state;
      originValue = activeTab === "2" ? "company-list" : "billing-usage";
    } else {
      const locationValue = location.pathname.replaceAll("/", "");
      locationValue === "admin-settings"
        ? (originValue = "user-list")
        : locationValue === "data-dictionary"
        ? (originValue = "dictionary-list")
        : locationValue === "projects"
        ? (originValue = "project-list")
        : locationValue === "platform-settings"
        ? (originValue = "ratecard-list")
        : locationValue === "custom-data"
        ? (originValue = "customdata-list")
        : locationValue === "collector-management"
        ? (originValue = "collector-management-list")
        : (originValue = locationValue);
    }
    window.datazoom &&
      window.datazoom.generateEvent("nav", {
        origin: originValue,
        target: tabValue.replaceAll("/", ""),
        method: "header",
        userid: currentUser.email,
        company: companyName,
      });
  };

  const handletoggle = () => {
    setTimeout(() => {
      const newValue = !isNewVersion;
      setIsNewVersion(newValue);
      localStorage.setItem("newPipeUI", newValue.toString());
    }, 500);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
      <Menu
        // anchorEl={adminMenuClick}
        open={adminMenuClick}
        onClose={closeMenu}
        onClick={closeMenu}
        id="admin-menu"
        PaperProps={{
          elevation: 0,
          sx: {
            mt: 1.5,
            top: "36px !important",
            right: "26px",
            ml: "-10px",
            left: "auto !important",
            width: "250px !important",
            maxHeight: "446px !important",
            backgroundColor: "#FFFFFF !important",
            boxShadow:
              "0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.20) !important",
            cursor: "inherit",
            "& .MuiSvgIcon-root": {
              width: 24,
              height: 24,
              ml: "4px",
              mr: "10px",
              marginTop: "0px",
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDivider-root": {
              marginTop: "4px !important",
              marginBottom: "4px !important",
            },
            "& .MuiListItemIcon-root": {
              fontSize: "16px",
              color: "rgba(0,0,0,0.60) !important",
              letterSpacing: "0.15px",
              lineHeight: "26px",
              fontWeight: 400,
            },

            "& .MuiListItemIcon-root:hover": {
              color: "#263238 !important",
            },
          },
        }}
        transformOrigin={{ horizontal: "center", vertical: "top" }}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Link
          to={users}
          onClick={/* istanbul ignore next */ () => handleChange("user-list")}
          style={{ color: "inherit" }}
        >
          <MenuItem>
            <ListItemIcon>
              <PersonOutlineOutlinedIcon />
              Users
            </ListItemIcon>
          </MenuItem>
        </Link>
        <Link
          to={projects}
          onClick={
            /* istanbul ignore next */ () => handleChange("project-list")
          }
          style={{ color: "inherit" }}
        >
          <MenuItem>
            <ListItemIcon>
              <FolderOutlinedIcon />
              Projects
            </ListItemIcon>
          </MenuItem>
        </Link>

        <Link
          to={datapipe_list}
          onClick={
            /* istanbul ignore next */ () => {
              handletoggle();
              handleChange("datapipe-list");
            }
          }
          style={{ color: "inherit" }}
        >
          <MenuItem>
            <ListItemIcon>
              <SvgIcon
                stroke="currentColor"
                fill="none"
                style={{
                  transform: isNewVersion ? undefined : "scaleX(-1)",
                  width: 23,
                  height: 22,
                }}
              >
                <path
                  d="
      M21.2805 8.34146V5.41464C21.2805 3.52879 19.7517 2 17.8659 2H5.42683C3.54098 2 2.0122 3.52878 2.0122 5.41463V18.5854C2.0122 20.4712 3.54098 22 5.42683 22H10.5488
      M18.3537 22C20.6436 22 22.5 20.1436 22.5 17.8537V17.6098C22.5 15.1851 20.5344 13.2195 18.1098 13.2195H11.0366
      M14.939 8.34146L10.8584 12.8755C10.6848 13.0684 10.6926 13.3633 10.876 13.5468L14.939 17.6098
    "
                  strokeWidth="1.9"
                  fill="none"
                />
              </SvgIcon>
              {isNewVersion ? "Previous Site Version" : "New Site Version"}
            </ListItemIcon>
          </MenuItem>
        </Link>

        {roleName === SUPER_ADMIN_ROLE && (
          <Link
            onClick={
              /* istanbul ignore next */ () => handleChange("customdata-list")
            }
            to={custom_data}
            style={{ color: "inherit" }}
          >
            <MenuItem>
              <ListItemIcon>
                <DashboardCustomizeOutlinedIcon />
                Custom Data
              </ListItemIcon>
            </MenuItem>
          </Link>
        )}
        {(roleName === SUPER_ADMIN_ROLE ||
          (roleName === BILLING_ADMIN && auth.cardData)) && (
          <Link
            onClick={
              /* istanbul ignore next */ () => handleChange("billing-usage")
            }
            to={{ pathname: admin_settings, state: { activeTab: "3" } }}
            style={{ color: "inherit" }}
          >
            <MenuItem>
              <ListItemIcon>
                <AttachMoneyOutlinedIcon />
                Billing & Usage
              </ListItemIcon>
            </MenuItem>
          </Link>
        )}

        {isSuperAdmin && roleName === SUPER_ADMIN_ROLE && (
          <>
            <Divider />
            <Box>
              <Link
                onClick={
                  /* istanbul ignore next */ () => handleChange("company-list")
                }
                to={companies}
                style={{ color: "inherit" }}
              >
                <MenuItem>
                  <ListItemIcon>
                    <BusinessOutlinedIcon />
                    Companies
                  </ListItemIcon>
                </MenuItem>
              </Link>
              <Link
                onClick={
                  /* istanbul ignore next */ () => handleChange("ratecard-list")
                }
                to={rate_cards}
                style={{ color: "inherit" }}
              >
                <MenuItem>
                  <ListItemIcon>
                    <PriceChangeOutlinedIcon />
                    Rate Cards
                  </ListItemIcon>
                </MenuItem>
              </Link>

              <Link
                onClick={
                  /* istanbul ignore next */ () =>
                    handleChange("dictionary-list")
                }
                to={data_dictionary}
                style={{ color: "inherit" }}
              >
                <MenuItem>
                  <ListItemIcon>
                    <FeaturedPlayListOutlinedIcon />
                    {DATA_DICTIONARY}
                  </ListItemIcon>
                </MenuItem>
              </Link>

              <Link
                onClick={
                  /* istanbul ignore next */ () =>
                    handleChange("collector-management-list")
                }
                to={collector_management}
                style={{ color: "inherit" }}
              >
                <MenuItem>
                  <ListItemIcon>
                    <SvgIcon>
                      <path d="M19.3377 13.532C19.1277 13.308 17.7267 11.809 17.3267 11.418C17.0464 11.1493 16.673 10.9995 16.2847 11H14.5277L17.5917 13.994H14.0477C13.9996 13.9931 13.952 14.0049 13.9099 14.0283C13.8678 14.0516 13.8325 14.0857 13.8077 14.127L14.0477 13.994H5.95174L6.19174 14.127C6.1668 14.0858 5.99384 14.0173 5.95174 13.994C5.99987 13.9933 5.90964 13.9707 5.95174 13.994H2.40774L5.47074 11H3.71474C3.31774 11 2.93874 11.159 2.67274 11.418C2.27274 11.81 0.871737 13.309 0.661737 13.532C0.172737 14.053 -0.0962632 14.468 0.0317368 14.981L0.592737 18.055C0.720737 18.569 1.28374 18.991 1.84474 18.991H18.1567C18.7177 18.991 19.2807 18.569 19.4087 18.055L19.9697 14.981C20.0957 14.468 19.8277 14.053 19.3377 13.532Z M15.0312 4.03125L14.1532 4.63539C13.4519 5.11836 12.9105 5.56631 12.5482 6.18398C12.2129 6.75568 12.0382 7.47305 12.0057 8.42416H14.8125L9.89062 12.9688L4.96875 8.42416H7.7909C7.87293 6.85838 8.53137 5.69178 9.75281 4.95314C10.7656 4.34148 12.1654 4.03125 13.9173 4.03125H15.0312Z" />
                    </SvgIcon>
                    Collector Management
                  </ListItemIcon>
                </MenuItem>
              </Link>
              <MenuItem
                onClick={() => refreshHelpSite()}
                style={{ color: "inherit" }}
              >
                <ListItemIcon>
                  <RefreshIcon />
                  Refresh Help Site
                </ListItemIcon>
              </MenuItem>
            </Box>
          </>
        )}

        {process.env.REACT_APP_EPG_ENRICHMENT === "true" &&
          roleName !== USER_ROLE && (
            <Link
              onClick={
                /* istanbul ignore next */ () => handleChange("epg_enrichment")
              }
              to={epg_enrichment}
              style={{ color: "inherit" }}
            >
              <MenuItem>
                <ListItemIcon>
                  <SvgIcon viewBox="0 0 100 100">
                    <path
                      d="M5 50 H55
                        M40 35 L55 50 L40 65
                        M65 20 Q85 20 85 35 L85 42 Q85 50 75 50
                        Q85 50 85 58 L85 65 Q85 80 65 80"
                      stroke="currentColor"
                      strokeWidth="8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </SvgIcon>
                  EPG Enrichment
                </ListItemIcon>
              </MenuItem>
            </Link>
          )}
      </Menu>
    </Box>
  );
}
export default AdminMenu;
